import {ReactNode, Ref} from 'react';
import cn from 'classnames';

//Utils
import { MakeRequired } from '~utils/typescriptHelpers';



export interface FloatingLabelInputProps extends MakeRequired<
    Omit<JSX.IntrinsicElements['input'], 'checked'>,
    'name' | 'type'
> {
    label?: ReactNode
    register?: any
    defaultValue?: string | number
    isDirty?: boolean
    isInvalid?: boolean
    isTouched?: boolean
    error?: string
    innerRef?: Ref<HTMLInputElement>
    hidePlaceholderOnFocus?: boolean
}


export default function FloatingLabelInput(
    {label, name, type, defaultValue, isDirty, isTouched, isInvalid, error, register, innerRef, hidePlaceholderOnFocus, id, ...rest}: FloatingLabelInputProps
) {
    const hookFormProps = register ? register(name) : {};

    return (
        <div
            className={cn('floating-label', {
                'is-required': rest.required,
                'is-dirty': isDirty,
                'is-touched': isTouched,
                'is-invalid': isInvalid,
                'hide-placeholder-on-focus': hidePlaceholderOnFocus
            })}
        >
            <input
                name={name}
                type={type}
                defaultValue={defaultValue}
                className="floating-label__input"
                placeholder=" "
                ref={innerRef}
                id={id}
                {...rest}
                {...hookFormProps}
            />

            <label htmlFor={id}>{label}</label>
            <div className="floating-label__border"/>

            {error && <div className="floating-label__error">{error}</div>}
        </div>
    );
}
